export function facebookLiveChatInit(language) {
    console.log('Facebook chat initialization')

    const appId = 213320349753425,
        pageId = 101404211414648

    function mount(cb) {
        if (document) {
            const body = document.querySelector('body')
            const element = document.createElement('div')
            element.classList.add('fb-customerchat')
            element.setAttribute('page_id', pageId)
            element.setAttribute('greeting_dialog_display', 'hide')
            if (body && body.append && typeof body.append === 'function') {
                body.append(element)
            }
            if (cb) {
                cb()
            }
        }
    }

    function __fbInited() {
        window.FB.init({
            appId: appId.toString(),
            status: true,
            xfbml: true,
            version: 'v7.0',
        })
    }

    mount(() => {
        if (window.FB) {
            __fbInited()
        } else {
            window.fbAsyncInit = function () {
                __fbInited()
            }
            // Load the SDK asynchronously
            ;(function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0]
                if (d.getElementById(id)) return
                js = d.createElement(s)
                js.id = id
                js.src = `https://connect.facebook.net/${language}/sdk/xfbml.customerchat.js`
                fjs.parentNode.insertBefore(js, fjs)
            })(document, 'script', 'facebook-jssdk')
        }
    })
}
